import React from "react";

const RadioInput = ({
	options,
	error,
	label,
	hideLabel,
	required,
	register,
	id,
	validate,
	style = "default",
	hide_options_if_only_one = false,
}) => {
	const renderRadioOption = (option) => {
		const inputId = `${id}-${option.value}`;
		const isLoading = option.loading;
		const isDisabled = option.disabled || isLoading;

		if (style === "boxes") {
			return (
				<div
					className={`form-check radio-box ${isLoading ? "loading" : ""}`}
					key={option.value}
				>
					<input
						type="radio"
						value={option.value}
						{...register(id, {
							required: required ? "Please select an option" : false,
							validate: validate,
						})}
						id={inputId}
						className={error ? "error" : ""}
						disabled={isDisabled}
					/>
					<label className="form-check-label radio-box-label" htmlFor={inputId}>
						{isLoading ? (
							<div className="radio-box-loading">
								<div className="loading-spinner"></div>
								<span className="radio-box-text">
									<div dangerouslySetInnerHTML={{ __html: option.label }} />
								</span>
							</div>
						) : option.image ? (
							<img
								src={option.image}
								alt={option.label}
								className="radio-box-image"
							/>
						) : (
							option.label
						)}
					</label>
				</div>
			);
		}

		if (style === "pills") {
			return (
				<div
					className={`form-check radio-pill ${isLoading ? "loading" : ""}`}
					key={option.value}
				>
					<input
						type="radio"
						value={option.value}
						{...register(id, {
							required: required ? "Please select an option" : false,
							validate: validate,
						})}
						id={inputId}
						className={error ? "error" : ""}
						disabled={isDisabled}
					/>
					<label
						className="form-check-label radio-pill-label"
						htmlFor={inputId}
					>
						{isLoading ? (
							<>
								<div className="loading-spinner"></div>
								<div dangerouslySetInnerHTML={{ __html: option.label }} />
							</>
						) : (
							<>
								<div dangerouslySetInnerHTML={{ __html: option.label }} />
								{option.value === "monthly" && (
									<span className="monthly-heart">
										<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
											<path d="M2 9.1371C2 14 6.01943 16.5914 8.96173 18.9109C10 19.7294 11 20.5 12 20.5C13 20.5 14 19.7294 15.0383 18.9109C17.9806 16.5914 22 14 22 9.1371C22 4.27416 16.4998 0.825464 12 5.50063C7.50016 0.825464 2 4.27416 2 9.1371Z" fill="#00288C"/>
										</svg>
									</span>
									)}
							</>
						)}
					</label>

					
				</div>
			);
		}

		// Default radio styling
		return (
			<div
				className={`form-check ${isLoading ? "loading" : ""}`}
				key={option.value}
			>
				<input
					type="radio"
					value={option.value}
					{...register(id, {
						required: required ? "Please select an option" : false,
						validate: validate,
					})}
					id={inputId}
					className={error ? "error" : ""}
					disabled={isDisabled}
				/>
				<label className="form-check-label" htmlFor={inputId}>
					{isLoading ? (
						<>
							<div className="loading-spinner"></div>
							<div dangerouslySetInnerHTML={{ __html: option.label }} />
						</>
					) : (
						<div dangerouslySetInnerHTML={{ __html: option.label }} />
					)}
				</label>
			</div>
		);
	};

	return (
		<>
			{hide_options_if_only_one && options?.length === 1 ? null : (
				<div className="form-field radio-field">
					{label && !hideLabel && (
						<label className="field-label">
							{label}
							{required && <span className="required">*</span>}
						</label>
					)}

					<div
						className={`radio-options ${
							style === "boxes" ? "radio-options--boxes" : ""
						} ${style === "pills" ? "radio-options--pills" : ""}`}
					>
						{options?.map(renderRadioOption)}
					</div>

					{options?.find((option) => option.description) && (
						<p className="field__description text-center">
							{options?.find((option) => option.description).description}
						</p>
					)}

					{error && <div className="field__error">{error.message}</div>}
				</div>
			)}
		</>
	);
};

export default RadioInput;
